import React from "react";
import {useRecoilState, useRecoilValue} from "recoil";
import theatreModeState from "../state/ui/theatreModeState";
import boothModeState from "../state/ui/boothModeState";
import tabState from "../state/ui/activeTabState";
import HelpModal from "./Modal/HelpModal";
import QualityModal from "./Modal/QualityModal";
import ProfileModal from "./Modal/ProfileModal";
import activeModalState from "../state/ui/activeModalState";
import useOuterClick from "../hooks/ui/useOuterClick";
import Tooltip from "./Tooltip";
import playerState from "../state/ui/playerState";
import useKeyboard from "../hooks/ui/useKeyboard";
import windowDimensionState from "../state/ui/windowDimensionState";
import VideoSettingModal from "./Modal/VideoSettingModal";
import { useTranslation } from "react-i18next";
import reviveModeState from "../state/ui/reviveModeState";
import { firebaseClaimsState } from "../state/firebaseState";

export default function Settings() {
  const {t} = useTranslation('lounge')
  const windowDimensions = useRecoilValue(windowDimensionState);
  const [activeTab, setShowTab] = useRecoilState(tabState);
  const [theatreMode, setTheatreMode] = useRecoilState(theatreModeState);
  const [activeModal, setShowModal] = useRecoilState(activeModalState);
  const {keyboard} = useKeyboard();
  const reviveMode = useRecoilValue(reviveModeState);
  const boothMode = useRecoilValue(boothModeState);
  const firebaseClaims = useRecoilValue(firebaseClaimsState);

  const isMobileView = windowDimensions.width < 768;
  const player = useRecoilValue(playerState);

  const closeModal = () => {
    setShowModal('')
  }
  const innerRef = useOuterClick(ev => {
    if (!isMobileView && activeModal !== '' && activeModal !== 'exit' && activeModal !== 'poll') {
          setShowModal('');
    }
  });

  return (
    <div className={`relative setting-container ${activeTab !== 2 && windowDimensions.width < 768 ? 'h-full' : ''}`} ref={innerRef}>
      <div
        className={`tab-view setting border-b border-gray-400 border-opacity-25 ${activeTab !== 4 ? 'hidden user-select-none' : ''} ${keyboard ? 'keyboard-mode' : ''}`}
      >
        <div className="px-2 py-2 flex flex-row justify-between">

          {/* Sound */}
          <div className={`flex-1 hidden md:flex md:order-1 mr-1 md:mr-0 ${reviveMode ? 'hint--top':'hint--bottom'} hint--bounce`} aria-label={t('sound')}>
            <button
              className={`btn-setting ${player.muted ? 'bg-red-500 bg-opacity-25 icon-muted' : 'hover:bg-white hover:bg-opacity-5'}`}
              onClick={() => {
                if(player.muted) {
                  window?.SpacePlayer?.unmute && window.SpacePlayer.unmute();
                }
                else {
                  window?.SpacePlayer?.mute && window.SpacePlayer.mute();
                }
                !isMobileView && closeModal();
              }}
            >
              <img src="/images/space/icon-sound.png"
                   className={`icon-setting ${player.muted ? '' : 'hover:bg-white hover:bg-opacity-5'}`}
                   draggable="false"></img>
            </button>
          </div>

          {/* Fullscreen */}
          <div className={`flex-1 hidden md:flex md:order-2 ${reviveMode ? 'hint--top':'hint--bottom'} hint--bounce`} aria-label={t('fullscreen')}>
            <button
              className="btn-setting hover:bg-white hover:bg-opacity-5"
              onClick={() => {
                closeModal();
                window?.SpacePlayer?.requestFullscreen && window.SpacePlayer.requestFullscreen();
              }}
            >
              <img src="/images/space/icon-fullscreen.png" className="icon-setting"
                   draggable="false"></img>
            </button>
          </div>

          {/* Theatre Mode */}
          {boothMode ? '':
            <div className={`flex-1 hidden-important md:order-3 ${reviveMode ? 'hidden':'md:flex hint--bottom hint--bounce'}`} aria-label={`${t('theatre-mode')}: ${theatreMode ? t('on') : t('off')}`}>
              <button
                className={`btn-setting ${theatreMode ? 'bg-green-300 bg-opacity-25' : 'hover:bg-white hover:bg-opacity-5'}`}
                onClick={() => {
                  setTheatreMode(prev => !prev);
                  closeModal();
                }}
              >
                <img src={`${theatreMode ? '/images/space/icon-theatre-2b.png' : '/images/space/icon-theatre-2a.png'}`}
                    className={`w-full h-6 object-contain m-auto ${theatreMode ? 'filter-green' : ''}`}
                    draggable="false"></img>
              </button>
            </div>
          }

          {/* Video Quality */}
          {(firebaseClaims?.isAdmin || window?.SpacePlayer?.setQuality || window?.SpacePlayer?.setTrack) &&
            <div className={`flex-1 hidden md:flex md:order-4 ${reviveMode ? 'hint--top':'hint--bottom'} hint--bounce`} aria-label={t('video-quality')}>
              <button
                className={`btn-setting hover:bg-white hover:bg-opacity-5`}
                onClick={() => {
                  setShowModal(prev => prev === 'quality' ? (isMobileView ? 'quality' : '') : 'quality')
                }}
              >
                <img src="/images/space/icon-setting.png"
                    className={`icon-setting`}
                    draggable="false"></img>
                {/* <div className="w-10/12 xl:w-8/12 h-6 m-auto icon-quality rounded-lg flex justify-center items-center">
                <p className="text-white font-extrabold uppercase">{player.selectedQuality || 'Auto'}</p>
                </div> */}
              </button>
            </div>
          }

          {/* Divider */}
          {boothMode ? '':
            <div className="hidden md:flex border-l border-gray-400 border-opacity-25 mx-1 md:order-5"></div>
          }

          {/* Profile */}
          {boothMode ? '':
            <div className={`flex-1 flex md:order-6 ${reviveMode ? 'hint--top':'hint--bottom'} hint--bounce`} aria-label={t('profile')}>
              <button
                className={`btn-setting ${isMobileView && activeModal === 'profile' ? 'bg-white bg-opacity-20' : 'hover:bg-white hover:bg-opacity-5'}`}
                onClick={() => {
                  setShowModal(prev => prev === 'profile' ? (isMobileView ? 'profile' : '') : 'profile')
                }}
              >
                <img src="/images/space/icon-user.png"
                    className={`icon-setting ${activeModal === 'profile' ? '' : (isMobileView ? '' : '')}`}
                    draggable="false"></img>
              </button>
            </div>
          }

          {/* Help */}
          {boothMode ? '':
            <div className={`flex-1 flex md:order-7 ${reviveMode ? 'hint--top':'hint--bottom'} hint--bounce`} aria-label={t('help')}>
              <button
                className={`btn-setting ${isMobileView && activeModal === 'faq' ? 'bg-white bg-opacity-20' : 'hover:bg-white hover:bg-opacity-5'}`}
                onClick={() => {
                  setShowModal(prev => prev === 'faq' ? (isMobileView ? 'faq' : '') : 'faq')
                }}
              >
                <img src="/images/space/icon-help.png"
                    className={`icon-setting ${activeModal === 'faq' ? '' : (isMobileView ? '' : '')}`}
                    draggable="false"></img>
              </button>
            </div>
          }

          {/* Exit */}
          <div className={`flex-1 flex md:order-8 ${reviveMode ? 'hint--top':'hint--bottom'} hint--bounce`} aria-label={t('exit')}>
            <button
              className={`btn-setting ${isMobileView ? 'md:bg-white md:bg-opacity-20' : 'hover:bg-white hover:bg-opacity-5'}`}
              onClick={() => {
                setShowModal(prev => prev === 'exit' ? (isMobileView ? 'exit' : '') : 'exit')
              }}
            >
              <img src="/images/space/icon-exit.png"
                   className={`icon-setting`}
                   draggable="false"></img>
            </button>
          </div>

        </div>
      </div>
      <ProfileModal/>
      <HelpModal/>
      {(firebaseClaims?.isAdmin || window?.SpacePlayer?.setQuality || window?.SpacePlayer?.setTrack) &&
        <QualityModal/>
      }
      <VideoSettingModal/>
    </div>
  )
}
